import {translations} from "../../app/pages/settings/translations/list";

export default {
    header: {
        self: {},
        items: [
            {
                title: "Quality Management System",
                root: true,
                alignment: "left",
                page: "dashboard",
                translate: "MENU.DASHBOARD",
            },

        ],
    },
    aside: {
        self: {},
        items: [
            {
                title: "Dashboard",
                root: true,
                icon: "flaticon-dashboard",
                page: "dashboard",
                translate: "MENU.DASHBOARD",
                bullet: "dot",
                roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
            },


            {
                title: "Buyer Parents",
                translate: "MENU.BUYER_PARENTS",
                root: true,
                bullet: "dot",
                icon: "flaticon2-shopping-cart",
                page: 'buyer/parents',
                roles: ['SUPER_ADMIN', 'ADMIN']
            },
            {
                title: "Grower Parents",
                translate: "MENU.GROWER_PARENTS",
                root: true,
                bullet: "dot",
                icon: "flaticon-buildings",
                page: 'grower/parents',
                roles: ['SUPER_ADMIN', 'ADMIN']
            },
            {
                title: "Buyers",
                translate: "MENU.BUYERS",
                root: true,
                bullet: "dot",
                icon: "flaticon2-delivery-package",
                page: 'buyers',
                roles: ['SUPER_ADMIN', 'ADMIN']
            },
            {
                title: "Growers",
                translate: "MENU.GROWERS",
                root: true,
                bullet: "dot",
                icon: "flaticon2-shelter",
                page: 'growers',
                roles: ['SUPER_ADMIN', 'ADMIN']
            },
            {
                title: "Reports",
                translate: "MENU.REPORTS",
                root: true,
                icon: "flaticon2-analytics",
                roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR'],
                submenu: [
                    {
                        title: "Plants",
                        translate: "MENU.REPORTS.PLANTS",
                        root: true,
                        roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR'],
                        submenu: [
                            {
                                title: "Buyers",
                                translate: "MENU.REPORTS.PLANTS.BUYER",
                                root: true,
                                icon: "flaticon2-delivery-package",
                                page: "reports/plants/buyer",
                                roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
                            },
                            {
                                title: "Growers",
                                translate: "MENU.REPORTS.PLANTS.GROWER",
                                root: true,
                                icon: "flaticon2-open-box",
                                page: "reports/plants/grower",
                                roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
                            },
                        ]
                    },
                    {
                        title: "Flowers",
                        translate: "MENU.REPORTS.FLOWERS",
                        root: true,
                        roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR'],
                        submenu: [
                            {
                                title: "Buyers",
                                translate: "MENU.REPORTS.PLANTS.BUYER",
                                root: true,
                                icon: "flaticon2-delivery-package",
                                page: "reports/flowers/buyer",
                                roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
                            },
                            {
                                title: "Growers",
                                translate: "MENU.REPORTS.PLANTS.GROWER",
                                root: true,
                                icon: "flaticon2-open-box",
                                page: "reports/flowers/grower",
                                roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
                            },
                            {
                                title: "Temperature",
                                translate: "MENU.REPORTS.TEMPERATURE",
                                icon: "flaticon-light",
                                root: true,
                                page: "temperature",
                                roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR'],
                            },
                            {
                                title: "Shipment",
                                translate: "MENU.REPORTS.SHIPMENT",
                                icon: "flaticon2-tools-and-utensils",
                                root: true,
                                page: "shipment",
                                roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR'],
                            },
                            {
                                title: "Inspection",
                                translate: "MENU.REPORTS.INSPECTION",
                                icon: "flaticon2-graph-1",
                                root: true,
                                page: "flower/inspection",
                                roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR'],
                            },
                            {
                                title: "Criteria",
                                translate: "MENU.REPORTS.CRITERIA",
                                icon: "flaticon2-graph-2",
                                root: true,
                                page: "criteria",
                                roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR'],
                            },
                        ]
                    },


                ]
            },
            {
                title: "Languages",
                translate: "MENU.LANGUAGES",
                root: true,
                icon: "fas fa-language",
                page: "language",
                roles: ['SUPER_ADMIN', 'ADMIN']
            },
            {
                title: "Users",
                translate: "MENU.USERS",
                root: true,
                icon: "flaticon-users",
                page: "users",
                roles: ['SUPER_ADMIN', 'ADMIN']
            },
            {
                title: "Freight Forwarders",
                translate: "MENU.FREIGHT_FORWARDERS",
                root: true,
                icon: "flaticon2-delivery-truck",
                page: "freightForwarder",
                roles: ['SUPER_ADMIN', 'ADMIN']
            },
            {
                title: "Locations",
                translate: "MENU.LOCATIONS",
                root: true,
                icon: "flaticon-map-location",
                roles: ['SUPER_ADMIN', 'ADMIN'],
                submenu: [
                    {
                        title: "Delivery",
                        translate: "MENU.LOCATIONS.DELIVERY",
                        root: true,
                        bullet: "dot",
                        page: "deliveryLocation",
                        roles: ['SUPER_ADMIN', 'ADMIN']
                    },
                ]
            },

            {
                title: "Settings",
                translate: "MENU.SETTINGS",
                root: true,
                icon: "flaticon-settings-1",
                page: "settings",
                roles: ['SUPER_ADMIN', 'ADMIN'],
                displaySubmenu: false,
                submenu: translations().reduce((modules, moduleName) => {
                    modules.push({
                        title: moduleName,
                        translate: `SETTINGS.${moduleName}`,
                        page: `settings/${moduleName}`,
                        roles: ['SUPER_ADMIN', 'ADMIN'],
                        visible: false
                    });
                    return modules;
                }, [])

            },

        ]
    }
};
